import { createSelectorCreator, lruMemoize } from 'reselect';
import { shallowEqual } from 'react-redux';

const createShallowEqualSelector = createSelectorCreator((func) =>
  lruMemoize(func, shallowEqual),
);

export default createShallowEqualSelector;
